export const THEME = {
  MAX_WITH: "52.5rem"
};
